<template>
    <admin-dashboard-layout>
        <v-data-table
            :search="search"
            :loading="loading"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="filteredUsers"
            :items-per-page="quantityItems"
            class="elevation-1"
            @click:row="handleClickRow"
        >
            <template v-slot:top>
                <v-row class="mx-4" dense>
                    <v-col cols="12" md="8">
                        <v-text-field
                            v-model="search"
                            label="Search"
                            class="mx-4"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-select
                            v-model="moderatorFilter"
                            :items="moderatorOptions"
                            item-text="text"
                            item-value="value"
                            label="Filter by Moderator"
                            class="mx-4"
                            dense
                            hide-details
                        ></v-select>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.created_at="{ item }">
                {{ item.created_at ? moment(item.created_at).format('LLL') : '' }}
            </template>
            <template v-slot:item.blocked_at="{ item }">
                {{ item.blocked_at ? moment(item.blocked_at).format('LLL') : '' }}
            </template>
            <template v-slot:item.is_online="{ item }">
                <v-badge color="ml-3 success" :title="'Last online ' + moment(item.last_online_at).format('LLL')"
                         v-if="item.is_online"></v-badge>
                <v-badge color="ml-3 error" :title="'Last online ' + moment(item.last_online_at).format('LLL')"
                         v-else></v-badge>
            </template>
                <template v-slot:item.name="{ item }">
                <span class="moderateIcon">
                    {{ item.name }}
                    <moderator-badge-icon :width="15" v-if="item.is_moderator"></moderator-badge-icon>
                </span>
                </template>
        </v-data-table>
    </admin-dashboard-layout>
</template>

<script>
import User from '../../../models/admin/User';
import AdminDashboardLayout from "../../../layouts/AdminDashboardLayout";
import {ADMIN_QUANTITY_ITEMS_LIST} from "../../../configs/constants";
import ModeratorBadgeIcon from "@/components/app/icons/ModeratorBadgeIcon";
import {mapMutations} from "vuex";
/* eslint-disable */
export default {
    name: "users-index",
    components: {AdminDashboardLayout, ModeratorBadgeIcon},
    data: function () {
        return {
            loading: false,
            quantityItems: ADMIN_QUANTITY_ITEMS_LIST,
            users: [],
            search: '',
            headers: [
                {
                    text: '# ID',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {text: 'Name', value: 'name'},
                {text: 'Email', value: 'email'},
                {text: 'Created at', value: 'created_at'},
                {text: 'Blocked at', value: 'blocked_at'},
                {text: 'Status', value: 'is_online'},
            ],
            moderatorFilter: '',
            moderatorOptions: [
                { text: 'All', value: '' },
                {text: 'Moderator', value: true}
            ]
        }
    },
    methods: {
        handleClickRow(user) {
            this.$router.push({name: 'admin.users.show', params: {id: user.id}})
        },
        handlePusherListener() {
            this.$echo.connector.connect()
            this.$echo.private('user-registered')
                .listen('UserSignUpEvent', async (data) => {
                    if (typeof data.message !== 'undefined') {
                        this.showSnackBar(data.message)
                        this.users = await User.get()
                    }
                })
                .error((err) => {
                    console.error(err)
                })
        },
        ...mapMutations(['showSnackBar'])
    },
    computed: {
        filteredUsers() {
            if (this.moderatorFilter === '') return this.users
            return this.users.filter(user => user.is_moderator === this.moderatorFilter)
        },
        refreshTime() {
            const minute = 60000
            if (process.env.VUE_APP_LAST_ONLINE_REFRESH_MINUTES) {
                return process.env.VUE_APP_LAST_ONLINE_REFRESH_MINUTES * minute
            }
            return 10 * minute
        }
    },
    async mounted() {
        this.loading = true
        this.users = await User.get()
        this.loading = false
        setInterval(async () => {
            this.users = await User.get()
        }, this.refreshTime)
        this.handlePusherListener()
    },
}
</script>

<style scoped>
    .v-text-field.v-input--dense {
        padding-top: 18px;
    }
    .moderateIcon {
        display: inline-flex;
        align-items: center;
        gap: 4px;
    }
</style>
